type IconProps = React.ComponentProps<'svg'>

export function Menu03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 5.25)">
        <path
          d="M12.75 12c0.41421 0 0.75 0.33579 0.75 0.75 0 0.41421-0.33579 0.75-0.75 0.75l-12 0c-0.41421 0-0.75-0.33579-0.75-0.75 0-0.41421 0.33579-0.75 0.75-0.75l12 0z m6-6c0.41421 0 0.75 0.33579 0.75 0.75 0 0.41421-0.33579 0.75-0.75 0.75l-18 0c-0.41421 0-0.75-0.33579-0.75-0.75 0-0.41421 0.33579-0.75 0.75-0.75l18 0z m0-6c0.41421 0 0.75 0.33579 0.75 0.75 0 0.41421-0.33579 0.75-0.75 0.75l-18 0c-0.41421 0-0.75-0.33579-0.75-0.75 0-0.41421 0.33579-0.75 0.75-0.75l18 0z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
